// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	AnnouncementSelectField,
	CalendarEventSelectField,
	ClassYearCategorySelectField,
	ClassYearSelectField,
	CourseSectionSelectField,
	HomeRoomSectionSelectField,
	NewsletterSelectField,
	PostSelectField,
	StudentNoteSelectField,
	UserGroupSelectField,
	UserSelectField,
} from "../../Forms";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues & IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "isPublic" },
		{ value: "includeEmployees" },
		{ value: "includeGuardians" },
		{ value: "includeAllUsersOfPersonTypes" },
		{ value: "announcement" },
		{ value: "calendarEvent" },
		{ value: "classYearCategories" },
		{ value: "classYears" },
		{ value: "courseSections" },
		{ value: "homeRoomSections" },
		{ value: "newsletter" },
		{ value: "post" },
		{ value: "sharedUsers" },
		{ value: "studentNote" },
		{ value: "userGroups" },
		{ value: "users" },
	],
	fieldComparisonOptions: {
		isPublic: IndexForms.booleanComparisonOptions,
		includeEmployees: IndexForms.booleanComparisonOptions,
		includeGuardians: IndexForms.booleanComparisonOptions,
		includeAllUsersOfPersonTypes: IndexForms.booleanComparisonOptions,
		announcement: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		calendarEvent: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		classYearCategories: IndexForms.multipleEdgeComparisonOptions,
		classYears: IndexForms.multipleEdgeComparisonOptions,
		courseSections: IndexForms.multipleEdgeComparisonOptions,
		homeRoomSections: IndexForms.multipleEdgeComparisonOptions,
		newsletter: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		post: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		sharedUsers: IndexForms.multipleEdgeComparisonOptions,
		studentNote: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		userGroups: IndexForms.multipleEdgeComparisonOptions,
		users: IndexForms.multipleEdgeComparisonOptions,
	},
	fieldComparisonTranslations: {
		isPublic: IndexForms.booleanComparisonTranslations,
		includeEmployees: IndexForms.booleanComparisonTranslations,
		includeGuardians: IndexForms.booleanComparisonTranslations,
		includeAllUsersOfPersonTypes: IndexForms.booleanComparisonTranslations,
		announcement: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				AnnouncementSelectField.Select,
				AnnouncementSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		calendarEvent: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				CalendarEventSelectField.Select,
				CalendarEventSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		classYearCategories: IndexForms.getMultipleEdgeComparisonTranslations(
			ClassYearCategorySelectField.Select,
			ClassYearCategorySelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		classYears: IndexForms.getMultipleEdgeComparisonTranslations(
			ClassYearSelectField.Select,
			ClassYearSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		courseSections: IndexForms.getMultipleEdgeComparisonTranslations(
			CourseSectionSelectField.Select,
			CourseSectionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		homeRoomSections: IndexForms.getMultipleEdgeComparisonTranslations(
			HomeRoomSectionSelectField.Select,
			HomeRoomSectionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		newsletter: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				NewsletterSelectField.Select,
				NewsletterSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		post: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				PostSelectField.Select,
				PostSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		sharedUsers: IndexForms.getMultipleEdgeComparisonTranslations(
			UserSelectField.Select,
			UserSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentNote: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				StudentNoteSelectField.Select,
				StudentNoteSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		userGroups: IndexForms.getMultipleEdgeComparisonTranslations(
			UserGroupSelectField.Select,
			UserGroupSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		users: IndexForms.getMultipleEdgeComparisonTranslations(
			UserSelectField.Select,
			UserSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
	},
};

registry.register("SharingRecord", advancedFilterInformation, {
	announcement: "Announcement",
	calendarEvent: "CalendarEvent",
	classYearCategories: "ClassYearCategory",
	classYears: "ClassYear",
	courseSections: "CourseSection",
	homeRoomSections: "HomeRoomSection",
	newsletter: "Newsletter",
	post: "Post",
	sharedUsers: "User",
	studentNote: "StudentNote",
	userGroups: "UserGroup",
	users: "User",
});
